import '../less/index.less';
import React from 'react';
import {DropDown, IconButton} from '@ab/components';
import {TYPE_BRANCHES, TYPE_PROCESSING} from '../variables';
import {palette} from '../../../palette';

export default function template() {
    if (!this.state.branchCourses) return null;

    let collection,
        rateToDisplay = null,
        {type, branchCourses, processingCourses} = this.state;

    if (type === TYPE_BRANCHES) {
        collection = branchCourses;
    } else if (type === TYPE_PROCESSING) {
        collection = processingCourses;
    }

    let usdUah = collection.get('USD-UAH'),
        eurUah = collection.get('EUR-UAH'),
        uahUsd = collection.get('UAH-USD'),
        uahEur = collection.get('UAH-EUR'),
        ratesList = null;

    if (this.isUiSubStateActive()) {
        ratesList = (
            <div className="list">
                <div className="component-control list-header">
                    <h3>{this.l10n('EX_RATES_TITLE')}</h3>
                    <DropDown
                        {...this.ctrlProps('type')}
                        className="type"
                        style={{
                            fontSize: palette.tsXSmall,
                        }}
                    >
                        <div value={TYPE_BRANCHES} name={this.l10n('EX_RATES_TYPE_BRANCHES')}>
                            {this.l10n('EX_RATES_TYPE_BRANCHES')}
                        </div>
                        <div value={TYPE_PROCESSING} name={this.l10n('EX_RATES_TYPE_PROCESSING')}>
                            {this.l10n('EX_RATES_TYPE_PROCESSING')}
                        </div>
                    </DropDown>
                    <IconButton>
                        <div className="list-header-img" onClick={e => this.deactivate(e)} />
                    </IconButton>
                </div>
                <div className="list-item">
                    <div className="list-item-label">{this.l10n('EX_RATES_LABEL_CURRENCY')}</div>
                    <div className="list-item-label">{this.l10n('EX_RATES_LABEL_BUY')}</div>
                    <div className="list-item-label">{this.l10n('EX_RATES_LABEL_SALE')}</div>
                </div>
                <div className="list-item">
                    <div className="list-item-label">{this.l10n('USD')}</div>
                    {usdUah ? (
                        <div className="list-item-value">
                            {usdUah.rateB().toString(null, null, null, 3)}
                        </div>
                    ) : null}
                    {uahUsd ? (
                        <div className="list-item-value">
                            {uahUsd.get('rateC').toString(null, null, null, 3)}
                        </div>
                    ) : null}
                </div>
                <div className="list-item">
                    <div className="list-item-label">{this.l10n('EUR')}</div>
                    {eurUah ? (
                        <div className="list-item-value">
                            {eurUah.rateB().toString(null, null, null, 3)}
                        </div>
                    ) : null}
                    {uahEur ? (
                        <div className="list-item-value">
                            {uahEur.get('rateC').toString(null, null, null, 3)}
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }

    if (uahUsd) {
        rateToDisplay = (
            <span className="item-rate">{uahUsd.get('rateC').toString(null, null, null, 3)}</span>
        );
    } else if (usdUah) {
        rateToDisplay = (
            <span className="item-rate">{usdUah.rateB().toString(null, null, null, 3)}</span>
        );
    }

    return (
        <div
            className={`module-ex-rates ${this.props.className || ''}`}
            onClick={e => this.activate()}
            onMouseEnter={e => this.activate()}
            onMouseLeave={e => this.deactivate()}
        >
            {ratesList}
            <div
                className="item"
                title={`${usdUah ? usdUah.rateB().toString(null, null, null, 3) : ''} / ${
                    uahUsd ? uahUsd.get('rateC').toString(null, null, null, 2) : ''
                }`}
            >
                <span className="item-label img-currency-usd" />
                {rateToDisplay}
            </div>
            <div className="item">
                <span className="slash">/</span>
            </div>
            <div
                className="item"
                title={`${eurUah.get('rateB').toString(null, null, null, 3)} / ${uahEur
                    .get('rateC')
                    .toString(null, null, null, 2)}`}
            >
                <span className="item-label img-currency-eur "></span>
                <span className="item-rate">
                    {uahEur.get('rateC').toString(null, null, null, 3)}
                </span>
            </div>
        </div>
    );
}
